import type { AxiosResponse } from 'axios';
import { httpWithAuth } from '~/clients';
import { FACET_DATA } from '~/constants/endpoints';
import { FacetData } from '~/contracts';
import { InventoryRequest } from '~/services/contracts';

export default function fetchFacetData(
  request: InventoryRequest,
  controller: AbortController
): Promise<AxiosResponse<FacetData>> {
  return httpWithAuth.post<FacetData>(FACET_DATA, request, {
    signal: controller.signal
  });
}
